module.exports = __webpack_public_path__ + "static/media/forward.18c4ea36.svg";